import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import en from 'element-ui/lib/locale/lang/en' // lang i18n
import '@/styles/index.scss' // global css
import App from './App'
import router from './router'

import '@/icons' // icon
import '@/permission' // permission control
import './assets/css/tailwind.css'
import MetaInfo from 'vue-meta-info'
import bottom from '@/components/bottom/index.vue'
/* 首页页脚*/
Vue.component('index_bottom', bottom)
// 设置使用en，默认配置中cn语言包依旧会引入
// Vue.use(ElementUI, { en })
// 如果想要中文版 element-ui，按如下方式声明
Vue.use(ElementUI)
// 时间格式化
Vue.use(require('vue-moment'))

Vue.use(MetaInfo)

// 开启警告
Vue.config.productionTip = false

Vue.directive('router-a', {
  inserted: function(el) {
    // 只处理站内链接（排除http/https开头的外部链接）
    if (el.tagName === 'A' && el.href && !el.href.startsWith('http')) {
      el.addEventListener('click', function(e) {
        e.preventDefault() // 阻止原生跳转

        // 提取相对路径（去除域名部分）
        const path = el.getAttribute('href') || ''
        if (path) {
          // 跳转前先规范化路径（移除末尾斜杠）
          const normalizedPath = path.replace(/\/+$/, '')
          router.push({ path: normalizedPath })
        }
      })
    }
  }
})

new Vue({
  el: '#app',
  router,
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  },
  render: h => h(App)
}).$mount('#app')
